<template>
  <div style="display: flex; flex-direction: column; height: 100%">
    <app-bar-desktop class="desktop-version"
                     :leftMenuIsOpen="drawerState"
                     @toggleMenu="drawerMenu=$event"
                     :value="drawerMenu"
    />

    <drawer :items="menu" @toggleDrawer="checkToggleDrawerState"/>

    <v-navigation-drawer
      v-model="drawerMenu"
      app
      right
      temporary
      style="top: 57px"
      height
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item>
            <v-list-item-title @click="gotTo('/settings')">Settings</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main app :style="styles">
      <template v-if="$route.name === 'Home'">
        <HomeDashboard/>
      </template>
      <template v-else>
        <router-view />
      </template>
    </v-main>
  </div>
</template>

<script>
import fakeData from '@/assets/fakeData'
import drawer from '@/components/layouts/drawer'
import AppBarDesktop from '@/components/layouts/App-bar-desktop'
import HomeDashboard from '@/views/home-dashboard'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'Index',
  components: { drawer, AppBarDesktop, HomeDashboard },
  data: () => ({
    ...fakeData,
    drawerState: false,
    drawerMenu: false
  }),
  mounted () {
    this.initializeDrawerState()
  },
  methods: {
    ...mapActions(['logout']),
    ...mapMutations(['SET_DATA']),

    initializeDrawerState () {
      const savedState = localStorage.getItem('drawerState')
      if (savedState !== null) {
        this.drawerState = JSON.parse(savedState)
      } else {
        this.drawerState = false
      }
    },

    checkToggleDrawerState (value) {
      this.drawerState = !value
      this.saveDrawerState(!value)
      this.SET_DATA(['drawerState', !value])
    },

    saveDrawerState (state) {
      localStorage.setItem('drawerState', JSON.stringify(state))
    },

    gotTo (path) {
      this.$router.push({ path })
    }
  },
  computed: {
    styles () {
      return {
        padding: this.drawerState ? '57px 0px 0px 180px' : '57px 0px 0px 56px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/fonts.scss';

  .v-application {
    &--wrap {
      header {
        border: none !important;
      }
      .v-toolbar {
        box-shadow: unset !important;
        .profile {
          &__title {
            font-weight: 600;
            font-size: 28px;
            color: #27272E;
          }
          &__logout {
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
